<template>
    <div style="text-align: left">
        <div class="list">学生管理</div>
        <div class="content">
            <div class="goods">
                <div style="flex:2;display: flex; ">

                    <div>
                        年级：<el-select clearable @change="gradeSearch" v-model="studentsList.grade" placeholder="请选择年级"
                            @focus="obtainGrade" style="width:200px">
                            <el-option v-for="(item, index) in options" :key="index" :label="item.grade"
                                :value="item.grade">
                            </el-option>
                        </el-select>
                        班级：<el-select :disabled="(studentsList.grade ? false : true)" clearable @change="classSearch"
                            v-model="studentsList.className" placeholder="请选择班级" @focus="obtainClass1" style="width:200px">
                            <el-option v-for="(item, index) in optionsClass1" :key="index" :label="item.className"
                                :value="item.className">
                            </el-option>
                        </el-select>
                        姓名：<el-input placeholder="请输入学生姓名" v-model.trim="studentsList.name" class="input-with-select"
                            style="max-width: 200px">
                        </el-input>
                        <el-button @click="searchStudent" type="primary" style="margin-left:10px">查 询</el-button>
                        <el-button @click="reset" type="primary" plain>重 置</el-button>
                        <el-button type="primary" plain @click="returnPage">返回</el-button>
                    </div>
                </div>
                <br />
                <hr>
                <div class="" style="margin-top: 20px;display: flex;">
                    <el-button type="primary" plain @click="openStudents">新增学生</el-button>
                    <el-button type="primary" plain @click="batchDelete">批量删除</el-button>
                    <el-button type="primary" plain @click="deleteGradeStudents">按年级删除</el-button>
                    <el-button type="primary" plain @click="deleteClassStudents">按班级删除</el-button>
                    <el-button type="primary" plain @click="downloadTemplate">导出模板</el-button>
                    <el-upload ref="xlsupload" class="upload-demo"
                        :headers="{ 'authorization': 'Bearer ' + this.authorization }"
                        :action="url + 'admin/excel/importExcel'" :multiple="false" :limit="1"
                        :on-success="importSuccess" accept=".xls, .xlsx" :data="{ campusId: this.studentsList.campusId }">
                        <el-button size="small" type="primary" style="margin-left:10px">点击上传</el-button>
                    </el-upload>
                </div>
            </div>
            <br />
            <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%;max-height: 600px; overflow: auto;"
                    @selection-change="handleSelectionChange" :cell-style="{ padding: 0 }" header-align="center">
                    <el-table-column type="selection" width="55" align="center">
                    </el-table-column>
                    <el-table-column type="index" width="50" label="序号" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="name" width="200" label="姓名" header-align="center" align="center">
                    </el-table-column>
                    <!-- <el-table-column label="性别" header-align="center" align="center" width="120">
                        <template slot-scope="scope">
                            <span v-if="scope.row.sex === '0'">男</span>
                            <span v-if="scope.row.sex === '1'">女</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="height" label="身高(cm)" header-align="center" align="center" width="120">
                    </el-table-column>
                    <el-table-column prop="weight" label="体重(kg)" header-align="center" align="center" width="120">
                    </el-table-column>
                    <el-table-column prop="grade" label="年级" header-align="center" align="center" width="120">
                    </el-table-column>
                    <el-table-column prop="className" label="班级" header-align="center" align="center" width="120">
                    </el-table-column>
                    <el-table-column prop="semester" label="学期" header-align="center" align="center" width="150">
                    </el-table-column>
                    <el-table-column prop="schoolYear" label="学年" header-align="center" align="center" width="120">
                    </el-table-column>
                    <el-table-column prop="birthday" label="生日" header-align="center" align="center" width="120">
                    </el-table-column>

                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="openEditorStudents(scope.row)">编辑</el-button>
                            <el-button @click="deleteStudents(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block1">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="studentsList.pageNum"
                    :page-size="studentsList.pageSize" layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>


            <!-- 新增学生 -->
            <el-dialog :title="(ruleForm.id ? '编辑' : '新增')" :visible.sync="dialogVisible" width="35%"
                :before-close="handleClose">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model.trim="ruleForm.name" placeholder="请输入学生姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="性别" prop="sex">
                        <template>
                            <el-radio v-model="ruleForm.sex" label="0">男</el-radio>
                            <el-radio v-model="ruleForm.sex" label="1">女</el-radio>
                        </template>
                    </el-form-item>
                    <el-form-item label="身高" prop="height">
                        <el-input v-model.trim="ruleForm.height" placeholder="请输入学生身高(cm)"></el-input>
                    </el-form-item>
                    <el-form-item label="体重" prop="weight">
                        <el-input v-model.trim="ruleForm.weight" placeholder="请输入学生体重(kg)"></el-input>
                    </el-form-item>
                    <el-form-item label="年级" prop="grade">
                        <template>
                            <el-select v-model="ruleForm.grade" placeholder="请选择年级" @focus="obtainGrade">
                                <el-option v-for="(item, index) in options" :key="index" :label="item.grade"
                                    :value="item.grade">
                                </el-option>
                            </el-select>
                        </template>
                    </el-form-item>
                    <el-form-item label="班级" prop="className">
                        <template>
                            <el-select v-model="ruleForm.className" placeholder="请选择班级" @focus="obtainClass"
                                @change="selectBank">
                                <el-option v-for="(item, index) in optionsClass" :key="index" :label="item.className"
                                    :value="{ value: item.className, label: item.classId }">
                                </el-option>
                            </el-select>
                        </template>
                    </el-form-item>
                    <el-form-item label="学期" prop="semester">
                        <template>
                            <el-select v-model="ruleForm.semester" placeholder="请选择学期" @focus="obtainsemester">
                                <el-option v-for="(item, index) in obtainSemester" :key="index" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </template>
                    </el-form-item>
                    <el-form-item label="学年" prop="schoolYear">
                        <el-input placeholder="请输入学期" v-model.trim="ruleForm.schoolYear"
                            :disabled="ruleForm.id === '' ? false : true"></el-input>
                    </el-form-item>
                    <el-form-item label="生日" prop="schoolYear">
                        <div class="block">
                            <el-date-picker v-model="ruleForm.birthday" type="date" placeholder="选择日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </div>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="resetForm('ruleForm')">取 消</el-button>
                    <el-button v-if="!ruleForm.id" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
                    <el-button v-if="ruleForm.id" type="primary" @click="editorStudents('ruleForm')">编 辑</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>


<script>
import request from '../utils/request'
import url from '../Api/imagesUrl'
export default {
    data() {
        return {
            url,
            authorization: '',
            tableData: [],
            studentsList: {
                campusId: '',
                className: '',
                grade: '',
                name: '',
                // idNumber: '',身份证号
                isPage: true,
                // name: '',
                pageNum: 1,
                pageSize: 50,
                // schoolYear: '',
                // scode: '',
                // semester: '',
                // sex: '',
                // weight: ''
            },
            // 控制新增学生窗口
            dialogVisible: false,
            // 新增学生表单
            ruleForm: {
                name: '',
                id: '',
                sex: '',
                height: '',
                weight: '',
                campus: '',
                campusId: '',
                grade: '',
                className: '',
                classId: '',
                semester: '',
                schoolYear: '',
                birthday: ''
            },
            // 新增学生的表单校验规则
            rules: {
                name: [{ required: true, message: '请输入学生姓名', trigger: 'blur' }],
                sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
                grade: [{ required: true, message: '请选择年级', trigger: 'blur' }],
                className: [{ required: true, message: '请选择班级', trigger: 'blur' }],
                semester: [{ required: true, message: '请选择学期', trigger: 'blur' }],
            },
            // 学校年级列表
            options: [],
            // 学校班级列表
            optionsClass: [],
            // 学校班级列表1
            optionsClass1: [],
            //学年表
            obtainSemester: [],
            // 删除学生表
            deleteStudentsForm: {
                campusId: '',
                className: '',
                grade: '',
                ids: []
            },
            // 多选表单
            batchList: [],
            // 分页
            total: 0
        }
    },
    created() {
        this.studentsList.campusId = this.$route.query.id
        this.ruleForm.campus = this.$route.query.schoolName
        this.ruleForm.campusId = this.$route.query.id
        this.deleteStudentsForm.campusId = this.$route.query.id
        this.authorization = sessionStorage.getItem('authorization')
        this.getStudentsList()
    },
    methods: {
        returnPage() {
            this.$router.go(-1)
        },
        // 多选
        handleSelectionChange(val) {
            //console.log('val', val);
            this.batchList = val
            //console.log('batch', this.batchList);
        },
        //查询学生列表
        async getStudentsList() {
            // //console.log(typeof this.studentsList.campusId);
            const res = await request({
                method: 'POST',
                url: 'admin/student/getStudentList',
                data: this.studentsList
            })
            if (res.code === '200') {
                //console.log(res);
                this.tableData = res.data && res.data.list
                this.total = res.data && res.data.total
            } else {
                this.$message.error(res.message)
            }
        },
        // 重置查询列表
        reset() {
            this.studentsList.className = ''
            this.studentsList.grade = ''
            this.studentsList.pageNum = 1
            this.studentsList.name = ''
            this.getStudentsList()
        },
        // 搜索学生
        searchStudent() {
            this.studentsList.pageNum = 1
            this.getStudentsList()
        },
        // 确定是否关闭新增学生窗口
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    this.resetAddStudents()
                    this.resetForm('ruleForm')
                    done();
                })
                .catch(() => { });
        },
        //打开新增学生弹窗
        openStudents() {
            this.dialogVisible = true
            this.resetAddStudents()
        },
        // 获取年级列表
        async obtainGrade() {
            //console.log(1);
            const res = await request({
                method: 'GET',
                url: `admin/student/getGrade?campusId=${this.ruleForm.campusId}`,
                data: {

                }
            })
            if (res.code === '200') {
                //console.log(res);
                this.options = res.data
            } else {
                this.$message.error(res.message)
            }
        },
        // 获取班级列表
        async obtainClass() {
            //console.log(1);
            const res = await request({
                method: 'GET',
                url: `admin/student/getClass?grade=${this.ruleForm.grade}`
            })
            if (res.code === '200') {
                //console.log(res);
                this.optionsClass = res.data
            } else {
                this.$message.error(res.message)
            }
        },
        // 获取学期
        obtainsemester() {
            let year = new Date().getFullYear()
            //console.log(year);
            this.obtainSemester = []
            this.obtainSemester.push('上学期')
            this.obtainSemester.push('下学期')
            this.ruleForm.schoolYear = year
        },
        // 新增学生表单验证
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.dialogVisible = false
                    this.addStudents()
                } else {
                    return false;
                }
            });
        },
        // 重置新增表单
        resetForm(formName) {
            this.dialogVisible = false
            this.resetAddStudents()
            this.$refs[formName].resetFields();
        },
        // 新增学生
        async addStudents() {
            const res = await request({
                method: "POST",
                url: 'admin/student/addStudent',
                data: this.ruleForm
            })
            if (res.code === '200') {
                //console.log(res);
                this.$message.success(res.message)
                this.studentsList.pageNum = 1
                this.resetAddStudents()
                this.getStudentsList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 班级新增的id
        selectBank(data) {
            const { value, label } = data
            //console.log(label);
            this.ruleForm.classId = label
            this.ruleForm.className = value
        },
        // 重置新增学生表单
        resetAddStudents() {
            this.ruleForm.name = ''
            this.ruleForm.sex = ''
            this.ruleForm.height = ''
            this.ruleForm.weight = ''
            this.ruleForm.grade = ''
            this.ruleForm.className = ''
            this.ruleForm.classId = ''
            this.ruleForm.semester = ''
            this.ruleForm.schoolYear = ''
            this.ruleForm.birthday = ''
            this.ruleForm.id = ''
        },
        // 打开编辑写生信息
        async openEditorStudents(val) {
            this.openStudents()
            //console.log(val);
            const res = await request({
                method: 'GET',
                url: `admin/student/getOneStudent?id=${val.id}`
            })
            if (res.code === '200') {
                //console.log(res);
                this.ruleForm.name = res.data.name
                this.ruleForm.id = res.data.id
                this.ruleForm.sex = res.data.sex
                this.ruleForm.height = res.data.height
                this.ruleForm.weight = res.data.weight
                this.ruleForm.campus = res.data.campus
                this.ruleForm.campusId = res.data.campusId
                this.ruleForm.grade = res.data.grade
                this.ruleForm.className = res.data.className
                this.ruleForm.classId = res.data.classId
                this.ruleForm.semester = res.data.semester
                this.ruleForm.schoolYear = res.data.schoolYear
                this.ruleForm.birthday = res.data.birthday
            } else {
                this.$message.error(res.message)
            }
        },
        // 编辑学生信息提交
        editorStudents(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.dialogVisible = false
                    const res = await request({
                        method: "POST",
                        url: 'admin/student/updateStudent',
                        data: this.ruleForm
                    })
                    if (res.code === '200') {
                        //console.log(res);
                        this.getStudentsList()
                        this.$message.success(res.message)
                    } else {
                        this.$message.error(res.message)
                    }
                } else {
                    return false;
                }
            });
        },
        //重置删除表单
        resetDeleteStudentsForm() {
            this.deleteStudentsForm.className = ""
            this.deleteStudentsForm.grade = ""
            this.deleteStudentsForm.ids = []
        },
        // 单个删除学生
        deleteStudents(val) {
            //console.log(val);
            this.$confirm('确认删除？')
                .then(async () => {
                    let ids = [val.id]
                    this.deleteStudentsForm.ids = ids
                    const res = await request({
                        method: 'POST',
                        url: 'admin/student/delStudent',
                        data: this.deleteStudentsForm
                    })
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        //console.log(res);
                        this.resetDeleteStudentsForm()
                        this.getStudentsList()
                    } else {
                        this.getStudentsList()
                        this.$message.error(res.message)
                    }
                })
                .catch(() => { });

        },
        //年级学生查询
        gradeSearch() {
            this.studentsList.className = ''
            this.studentsList.pageNum = 1
            this.deleteStudentsForm.className = ''
            this.deleteStudentsForm.grade = this.studentsList.grade
            this.getStudentsList()
        },
        // 获取班级列表1
        async obtainClass1() {
            const res = await request({
                method: 'GET',
                url: `admin/student/getClass?grade=${this.studentsList.grade}`
            })
            if (res.code === '200') {
                //console.log(res);
                this.optionsClass1 = res.data
            } else {
                this.$message.error(res.message)
            }
        },
        // 班级学生查询
        classSearch() {
            this.studentsList.pageNum = 1
            this.deleteStudentsForm.className = this.studentsList.className
            this.getStudentsList()
        },
        //按年级删除学生
        deleteGradeStudents() {
            //console.log(this.deleteStudentsForm);
            if (this.deleteStudentsForm.grade != '') {
                this.$confirm('确认删除？')
                    .then(async () => {
                        const res = await request({
                            method: 'POST',
                            url: 'admin/student/delStudent',
                            data: this.deleteStudentsForm
                        })
                        if (res.code === '200') {
                            this.resetDeleteStudentsForm()
                            this.getStudentsList()
                            this.$message.success(res.message)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(() => { });
            } else {
                this.$message.error("请选择年级")
            }
        },
        //按班级删除学生
        deleteClassStudents() {
            //console.log(this.deleteStudentsForm);
            if (this.deleteStudentsForm.className != '') {
                this.$confirm('确认删除？')
                    .then(async () => {
                        const res = await request({
                            method: 'POST',
                            url: 'admin/student/delStudent',
                            data: this.deleteStudentsForm
                        })
                        if (res.code === '200') {
                            this.resetDeleteStudentsForm()
                            this.reset()
                            this.$message.success(res.message)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(() => { });
            } else {
                this.$message.error("请选择班级")
            }
        },
        // 批量删除
        batchDelete() {
            if (this.batchList != '') {
                let ids = []
                this.batchList.forEach(val => {
                    ids.push(val.id)
                })
                this.deleteStudentsForm.ids = ids
                this.$confirm('确认删除？')
                    .then(async () => {
                        const res = await request({
                            method: 'POST',
                            url: 'admin/student/delStudent',
                            data: this.deleteStudentsForm
                        })
                        if (res.code === '200') {
                            this.resetDeleteStudentsForm()
                            this.reset()
                            this.$message.success(res.message)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(() => { });
            } else {
                this.resetDeleteStudentsForm()
                this.$message.error('请选择学生')
            }

        },
        // 导入文件成功时
        importSuccess(res) {
            //console.log("bbb");
            this.$refs['xlsupload'].clearFiles()
            if (res.code === '200') {
                this.$message.success(res.data)
            } else {
                this.$message.error(res.message)
            }

            this.reset()
        },
        // 下载模板
        async downloadTemplate() {
            const res = await request({
                method: 'POST',
                url: 'admin/excel/exportTemplate',
                responseType: 'blob'
            })
            const blob = new Blob([res])
            this.saveFile(blob, '学生模板.xls')
        },
        // 下载方法
        saveFile(data, name) {
            try {
                const blobUrl = window.URL.createObjectURL(data)
                const a = document.createElement('a')
                a.style.display = 'none'
                a.download = name
                a.href = blobUrl
                a.click()

            } catch (e) {
                alert('保存文件出错')
            }

        },
        // 分页
        handleCurrentChange() {
            this.getStudentsList()
        }

    },
    watch: {
        "studentsList.grade"(newVal) {
            // //console.log('newVal',newVal);
            if (newVal == '') {
                this.studentsList.className = ''
            } else {
                return
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
    // display: flex;
    justify-content: space-between;

    div {
        div {
            width: 100%;
        }

    }

    .input-with-select {
        padding: 0;
    }
}

.el-select .el-input {
    width: 130px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}

.block1 {
    background-color: #fff;
    text-align: right;
}
</style>